<template>
  <div>
    <Wizard :steps="stepValues" :currentStep="currentStep" />
    <TabbedPortletContainer>
      <router-view name="content" />
    </TabbedPortletContainer>
  </div>

</template>

<script>
import TabbedPortletContainer from '@/components/_shared/tabbed-portlet/TabbedPortletContainer.vue'
import Wizard from '@/components/_shared/wizard/Wizard.vue'
import WizardConfig from '@/components/_shared/wizard/config'

import ValidationsMixin from '@/mixins/validationsNewOpportunity.js'
import { restoreNewOpportunity } from '@/helpers'

export default {
  name: 'OpportunityNewContainer',
  mixins: [ValidationsMixin],
  components: {
    TabbedPortletContainer,
    Wizard
  },
  beforeMount () {
    const uuid = this.$route.params.privateId
    const data = restoreNewOpportunity(uuid)
    if (data) {
      this.$v.newOpportunity.$model = data
    }
  },
  data () {
    return {
      stepValues: WizardConfig.stepValues
    }
  },
  computed: {
    currentStep () {
      return this.$route.params.step
    }
  }
}
</script>
